module.exports = __webpack_public_path__ + "img/oss.74a822f9.png";